import { SplashHeader } from '../../pages/Login/SplashHeader';
import SplashFooter from '../../pages/Login/SplashFooter';
import ReleaseNotes from './ReleaseNotes';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var UnAuthedReleaseNotes = function () { return /*#__PURE__*/ _jsxs("div", { children: [/*#__PURE__*/ _jsx(SplashHeader, {}), /*#__PURE__*/ _jsx(ReleaseNotes, {}), /*#__PURE__*/ _jsx(SplashFooter, {})] }); };
